/*
 * Filename: template-configuration-body.component.tsx
 * Description: Landing page for template configuration.
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { CQTemplateSelectionPanel } from './template-selection-panel.component';
import { CQFormControlConfigurationRootComponent } from './layout-configuration-panel/form-control-configuration-root.component';
import ConfigTabsContainer from './config-tabs.container';
import CQTemplatePublishPanel from './template-publish-panel.component';
import TemplateConfigurationController from './template-config.controller';
import { schemaManager } from '../../common/components/validation/validation-schema-manager';
import { Formik } from 'formik';
import * as yup from 'yup';
import { LSTemplatesStore } from '../../store/ls-template-store';
import { CQGridTemplateSelectionPanel } from './grid-template-config/grid-template-selection-panel.component';
import  GridConfigTabsContainer  from './grid-template-config/grid-config-tabs.container';
import { CQGridontrolConfigurationRootComponent } from './grid-template-config/grid-right-pane.component';
import { CQAppConstant } from '../../app-constants';
import { BaseClassDataStore } from '../../store/base-class-store';
import { CQMasterDataStore } from '../../store/cq-master-data.store';
import { Utility } from '../../common/utility';

class CQTemplateConfigurationBody extends Component<{ history: any }, { selectedObject: string, selectedTemplateName: string, componentFields: any[], customComponent: any, resetAndDisableSelectionPanel: boolean }> {
    private readonly templateConfigCtrl: TemplateConfigurationController;
    private readonly utility : Utility;
    constructor(props: Readonly<{ history: any }>) {
        super(props);
        this.templateConfigCtrl = new TemplateConfigurationController();
        this.utility = new Utility();
        this.state = {
            selectedObject: '',
            selectedTemplateName: '',
            componentFields: [],
            customComponent: {},
            resetAndDisableSelectionPanel: false
        };
    }

    componentWillMount() {
        const template: any = this.templateConfigCtrl.getSelectedTemplate();
        let templateName= '';
        const componentFieldList = [];
        if (template && template.inputParams) {
            for (const key of Object.keys(template.inputParams)) {
                if (template.inputParams[key].isComponentProperty) {
                    componentFieldList.push({ ...template.inputParams[key], inputParamKey: key });
                }
            }
        }

        templateName = template.name;

        this.setState({ componentFields: componentFieldList, selectedTemplateName: templateName });
    }

    private resetAndDisableSelectionPanel = (shouldDisable: boolean) => {
        this.setState({ resetAndDisableSelectionPanel: shouldDisable });
    }

    public render(): ReactNode {
        const isLayoutAvailable = this.templateConfigCtrl.isLayoutFieldAvailable();
        let selectedTemplate: any = LSTemplatesStore.selectedTemplate;
        if (selectedTemplate.hasOwnProperty('selectedTemplate')) {
            selectedTemplate = this.utility.createObjectDeepCopy(selectedTemplate.selectedTemplate);
        }

        selectedTemplate = this.utility.createObjectDeepCopy(selectedTemplate);
        const schema = schemaManager(this.state.componentFields);
        const validateSchema = yup.object().shape(schema);

        return (
            <>
                <main className="full-height slds-p-around_small scroll-content">
                    <Formik validationSchema={validateSchema}
                        initialValues={this.getInitialValues(this.state.componentFields)}
                        onSubmit={e => { e.preventDefault(); }}>
                        {({ handleChange, handleSubmit, errors, isValidating, touched, dirty,
                            isSubmitting, isValid }) => (
                                <form className="full-height" action="#" onSubmit={e => { e.preventDefault(); }} onChange={this.handleChange}>
                                    <div className="slds-grid slds-grid_vertical full-height">
                                        <CQTemplatePublishPanel
                                            history={this.props.history}
                                            templateName={selectedTemplate && selectedTemplate.name}
                                            templateLabel={selectedTemplate && selectedTemplate.label}
                                            publishLWC={this.publishLWC}
                                            errors={errors}
                                            dirty={dirty}
                                            isValidating={isValidating}
                                            isSubmitting={isSubmitting}
                                            isValid={isValid} />
                                        {
                                            ( !selectedTemplate.name.includes('cqGridGenerator')) ?
                                            <div className="slds-grid slds-gutters_x-small full-height scroll-content">
                                                <CQTemplateSelectionPanel
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                    templateName={selectedTemplate && selectedTemplate.name}
                                                    isLayoutApplicable={isLayoutAvailable} 
                                                    shouldSelectionPanelResetAndDisable={this.state.resetAndDisableSelectionPanel}
                                                    setSelectedObject={this.setSelectedObject}/>
                                                <ConfigTabsContainer errors={errors} isLayoutApplicable={isLayoutAvailable}
                                                    selectedObject={this.state.selectedObject}
                                                    templateName={selectedTemplate.name} handleChange={handleChange}
                                                    updateIconName={this.updateIconName}
                                                    componentFields={this.state.componentFields}
                                                    selectedTemplateName={this.state.selectedTemplateName} 
                                                    resetAndDisableSelectionPanel={(value: boolean) => this.resetAndDisableSelectionPanel(value)}
                                                />
                                                <CQFormControlConfigurationRootComponent selectedTemplateName={selectedTemplate.name} />
                                            </div> : <div className="slds-grid slds-gutters_x-small full-height scroll-content">
                                                    <CQGridTemplateSelectionPanel
                                                        touched={touched}
                                                        errors={errors}
                                                        handleChange={handleChange}
                                                        templateName={selectedTemplate && selectedTemplate.name}
                                                        isLayoutApplicable={isLayoutAvailable} />
                                                    <GridConfigTabsContainer errors={errors} isLayoutApplicable={isLayoutAvailable}
                                                        templateName={selectedTemplate.name} handleChange={handleChange}
                                                        componentFields={this.state.componentFields}
                                                        selectedTemplateName={this.state.selectedTemplateName} 
                                                        setCustomComponent={this.setCustomComponent}/>
                                                    <CQGridontrolConfigurationRootComponent selectedTemplateName={selectedTemplate.name} selectedCustomComponent={this.state.customComponent}/>
                                                </div>
                                        }
                                    </div>
                                </form>
                            )}

                    </Formik>
                </main>
            </>
        );
    }

    private setCustomComponent = (customComponent :any) => {
        this.setState({ customComponent });
    }

    public handleChange = (e: any, elementType?: string) => {
        
        if (e.target.name !== 'picklistValueSource') {
            this.templateConfigCtrl.updateFormData(this.state.selectedTemplateName, e.target.name, e.target.value);
        }
    }

    public setSelectedObject = (selectedObjectName: string) => {
        this.setState({
            selectedObject:selectedObjectName
        })
    }

    private updateIconName = (iconClassName: string) => {
        
        this.templateConfigCtrl.updateFormData(this.state.selectedTemplateName, CQAppConstant.ICON_NAME,iconClassName);
    }

    /**
     * @memberof CQTemplateConfigurationBody
     */
    public updateOutputConfigStore = (e: any, elementType?: string) => {
        this.templateConfigCtrl.updateFormData(this.state.selectedTemplateName, e.target.name, e.target.value);
    }

    /**
     * @memberof CQTemplateConfigurationBody
     */
    public publishLWC = (value: any) => {
        let baseClassArray: string[] = []
        const baseClass = BaseClassDataStore.BaseClassObject[0];
        const outputConfig = CQMasterDataStore.OutputConfig;
        const { selectedObject } = outputConfig.getStoreData(value);
        if(baseClass.objects.hasOwnProperty(selectedObject)){
            baseClassArray = [baseClass.defaultclassName, ...Object.values(baseClass.objects[selectedObject].className)];
        }else{
            baseClassArray = [baseClass.defaultclassName];
        }
        this.templateConfigCtrl.publishLWC(value, false, baseClassArray);
    }

    /**
     * @param {*} inputs
     * @returns
     * @memberof CQTemplateConfigurationBody
     */
    public getInitialValues(inputs: any) {
        const initialValues: any = {};
        inputs.forEach((field: any) => {
            if (!initialValues[field.inputParamKey]) {
                initialValues[field.inputParamKey] = '';
            }
        });
        return initialValues;
    }
}
export const CQTemplateConfigurationBodyContainer = observer(CQTemplateConfigurationBody);
